









































































































































import { Component, Prop, Vue, Watch } from "@/shared/vuepack";
import { NotificationPreferenceUpdateRequest, TermsTab, UserOnboardingSteps, UserTermsType } from "@/shared/types";
import { BankCustodian } from "@/admin/types";
import * as RouteNames from "@/employee/route-names";
import Checkbox from "@/shared/components/ui/Checkbox.vue";
import Button from "@/shared/components/ui/Button.vue";
import Tab from "@/shared/components/ui/Tab.vue";
import TabGroup from "@/shared/components/ui/TabGroup.vue";
import TermsFeeSchedule from "./TermsFeeSchedule.vue";
import AvidiaTermsFeeSchedule from "./AvidiaTermsFeeSchedule.vue";
import AllegacyTermsFeeSchedule from "./AllegacyTermsFeeSchedule.vue";
import HsaBankFeeScheduleAndInterestRatesInfo
  from "@/employee/components/shared/HsaBankFeeScheduleAndInterestRatesInfo.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useUserStore } from "@/shared/store/user";
import { useEnrollmentStore } from "@/employee/store/enrollment";
import { usePortalCustomizationStore } from "@/shared/store/portalCustomization";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useWizardStore } from "@/employee/store/wizard";
import { useNotificationPreferencesStore } from "@/shared/store/notificationPreferences";

@Component({
  components: {
    Checkbox,
    Button,
    Tab,
    TabGroup,
    TermsFeeSchedule,
    AvidiaTermsFeeSchedule,
    AllegacyTermsFeeSchedule,
    HsaBankFeeScheduleAndInterestRatesInfo
  }
})
export default class Terms extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();
  userStore = useUserStore();
  enrollmentStore = useEnrollmentStore();
  portalCustomizationStore = usePortalCustomizationStore();
  featureFlagStore = useFeatureFlagStore();
  wizardStore = useWizardStore();
  notificationPreferencesStore = useNotificationPreferencesStore();

  readonly bendTermsAndConditionsFile = "bend_financial_terms_of_service 20181009.pdf";

  isSubmitting = false;
  isLoaded = true;
  agreedToESignTerms = false;
  agreedToTerms = false;
  agreedToPaperlessCommunications = false;
  TermsTab = TermsTab;
  activeTab = TermsTab.Bank;
  showPaperlessCommunicationsCheckBox = false;

  @Prop({ default: true })
  showHsaTerms: boolean;

  @Prop({ required: true })
  termsType: UserTermsType;

  @Prop()
  onBack: (hasUnsavedChanges: boolean) => void;

  mounted () {
    this.enrollmentStore.loadFeeWaiverSettings(this.userStore.partnerId);
    this.$on("tab-clicked", (event, tab) => {
      event.preventDefault();
      this.handleTabChange(tab.type);
    });

    if (this.featureFlagStore.flags.bend25434EnableNotificationPreferences && this.isInModal) {
      this.notificationPreferencesStore.getNotificationPreferences();
    }

    if (this.isInWizard && this.wizardStore.isStepComplete("terms-and-conditions")) {
      this.agreedToESignTerms = true;
      this.agreedToTerms = true;
    }
  }

  @Watch("notificationPreferencesStore.notificationPreferencesLoaded", {immediate: true})
  onNotificationPreferencesLoaded () {
    if (this.notificationPreferencesStore.notificationPreferencesLoaded) {
      if (this.featureFlagStore.flags.bend25434EnableNotificationPreferences &&
          this.notificationPreferencesStore.HasAnyPaperPreferencesOn &&
          this.isInModal) {
        this.showPaperlessCommunicationsCheckBox = true;
        this.agreedToPaperlessCommunications = true;
      }
    }
  }

  handleTabChange (tabType) {
    this.activeTab = tabType;
  }

  get hsaTermsLink (): string {
    return this.custodianSettingsStore.hsaTermsUrl ?
      this.custodianSettingsStore.hsaTermsUrl : this.termsAndConditionsHref;
  }

  get hsaTermsLinkDisplay () {
    return `${this.hsaTermsLink}#view=FitH`;
  }

  get termsAndConditionsHref () {
    return `/${this.bendTermsAndConditionsFile}`;
  }

  get submitDisabled () {
    return !this.agreedToESignTerms || !this.agreedToTerms || this.isSubmitting;
  }

  get isInWizard () {
    return this.termsType === UserTermsType.Wizard;
  }

  get isInModal () {
    return this.termsType === UserTermsType.Prompt;
  }

  get termsUrlDisplay () {
    return `${this.custodianSettingsStore.termsUrl}#view=FitH`;
  }

  onSubmit (): void {
    if (this.isSubmitting) {
      return;
    }

    if (!this.agreedToESignTerms && !this.agreedToTerms) {
      return;
    }

    this.isSubmitting = true;
    this.enrollmentStore.saveAgreedToTerms(this.eSignatureAgreedTo, this.termsType)
        .then(() => this.enrollmentStore.saveAgreedToTerms(this.custodianSettingsStore.termsUrl, this.termsType))
        .then(() => {
          if (this.showHsaTerms) {
            this.enrollmentStore.saveAgreedToTerms(this.hsaTermsLink, this.termsType);
          }
        })
        .then(() => {
          const result = this.enrollmentStore.saveAgreedToFeeTerms();

          if (this.termsType === UserTermsType.Wizard) {
            return this.enrollmentStore.termsAccepted();
          }
          return result;
        })
        .then(async () => {
          if (this.agreedToPaperlessCommunications) {
            await this.notificationPreferencesStore.savePaperlessNotificationPreferences();
          }
        })
        .then(() => this.$emit("complete"))
        .finally(() => this.isSubmitting = false);
  }

  get eSignatureAgreedTo () {
    if (this.custodianSettingsStore.displayPdfForESign) {
      return this.custodianSettingsStore.eSignPdfUrl;
    }

    return "inline-content-esign-disclosure-as-of-2021-07-13";
  }

  get showAllegacyDynamicFees (): boolean {
    return this.custodianSettingsStore.userCustodian === BankCustodian.Allegacy &&
        this.featureFlagStore.featureFlagsAvailable && this.featureFlagStore.flags.showDynamicAllegacyFees;
  }

  goBack () {
    if (this.onBack) {
      this.onBack(false);
    }
  }
}
